import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export type WorkQueuePriority = 'critical' | 'high' | 'medium' | 'low';
export type WorkQueueStatus = 'open' | 'in_progress' | 'pending' | 'overdue' | 'completed';

export interface WorkQueueItem {
  item_type: string;
  title: string;
  module: string;
  priority: WorkQueuePriority;
  status: WorkQueueStatus;
  association_id: number | null;
  due_date: string | null;
  days_overdue: number;
  required_action: string;
  source_entity_type: string;
  source_entity_id: number;
  url_path: string;
}

@Injectable({ providedIn: 'root' })
export class WorkQueueService {
  private http = inject(HttpClient);

  getMyQueue(filters: { priority?: string; item_type?: string; association_id?: number; limit?: number } = {}): Observable<any> {
    return this.http.get('api/work-queue/my', { params: filters as any });
  }
}
